import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`


  query formTemplatesByType($organizationId: UUID!,$typeId: UUID!) {
    formTemplatesByType(organizationId: $organizationId, typeId: $typeId )  {
      created_by_account_id
      created_ts
      id
      organization_id      
      title      
      type_id
      updated_ts
      type
    }
}
`;



export function apiGetFormTemplatesByType(organizationId, typeId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        if(!typeId) reject("typeId is required");

        client
            .query({
                query: query,
                variables: {organizationId, typeId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.formTemplatesByType);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get form templates");
                reject(err); // R
            })
    });
}
